export type MobileView = "game" | "menu" | "wallet" | "bag" | "settings";
export function MobileNavigation({ view, onChange }: { view: MobileView; onChange(view: MobileView): void }) {
  return <nav className="mobile-navigation" aria-label="Mobile game menu" onKeyDown={e => e.stopPropagation()}>
    <button className="mobile-menu-toggle" aria-expanded={view !== "game"} onClick={() => onChange(view === "game" ? "wallet" : "game")}>{view === "game" ? "☰ Menu" : "← Back to game"}</button>
    {view !== "game" && <div className="mobile-menu-options">
      {(["wallet", "bag", "settings"] as const).map(v => <button key={v} aria-pressed={view === v} onClick={() => onChange(v)}>{v === "wallet" ? "Wallet" : v === "bag" ? "Pokémon & items" : "Settings"}</button>)}
    </div>}
  </nav>;
}
